import React from "react";
import styled from "styled-components";
import { useTable } from "react-table";

const Styles = styled.div`
  width: 100%;
  overflow-x: auto;

  .admin-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;

    th,
    td {
      padding: 12px 16px;
      border-bottom: 1px solid #e2e8f0;
      text-align: left;
      font-size: 13px;
      vertical-align: middle;
    }

    th {
      background-color: #f8fafc;
      color: #475569;
      font-weight: 700;
      text-transform: uppercase;
      font-size: 11px;
      letter-spacing: 0.05em;
      border-bottom: 2px solid #cbd5e1;
      white-space: nowrap;
    }

    tbody tr {
      transition: background-color 0.15s ease-in-out;
      background-color: #ffffff;
    }

    tbody tr:hover {
      background-color: #f1f5f9;
    }

    tbody tr:last-child td {
      border-bottom: none;
    }
  }
`;

function AdminTable({ columns, filteredData }) {
  const tabaleData =
    filteredData?.length > 0
      ? filteredData
      : filteredData?.data?.length
      ? filteredData?.data
      : [];

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data: tabaleData,
    });

  return (
    <Styles>
      <table {...getTableProps()} className="admin-table">
        <thead>
          {headerGroups.map((headerGroup) => {
            const { key, ...headerGroupProps } =
              headerGroup.getHeaderGroupProps();
            return (
              <tr key={key} {...headerGroupProps}>
                {headerGroup.headers.map((column) => {
                  const { key: columnKey, ...headerProps } =
                    column.getHeaderProps();
                  return (
                    <th
                      key={columnKey}
                      {...headerProps}
                      style={{ width: column.width ? column.width : "auto" }}
                    >
                      {column.render("Header")}
                    </th>
                  );
                })}
              </tr>
            );
          })}
        </thead>

        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            const { key, ...rowProps } = row.getRowProps();
            return (
              <tr key={key} {...rowProps}>
                {row.cells.map((cell) => {
                  const { key: cellKey, ...cellProps } = cell.getCellProps();
                  return (
                    <td key={cellKey} {...cellProps}>
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </Styles>
  );
}

export default AdminTable;
